<template>
  <v-app-bar class="pa-n3" color="accent" elevate-on-scroll scroll-target="#scrolling-techniques-7">
    <v-container>
      <v-row align="center" justify="center">
        <v-btn class="mr-7 convert-now-btn" elevation="2" @click="upgrade">{{ $t('message') }} »</v-btn>
        {{ proAdvantage }}
        <v-icon class="ml-3" color="secondary">fa-bolt</v-icon>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import Advantages from '../assets/proAdvantages';

export default {
  name: 'TopProCTA',
  data() {
    return {
      proAdvantage: '',
      overlaySeeAdvantages: true,
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.refreshProAdvantage();
    },
    '$i18n.locale': function () {
      this.refreshProAdvantage();
    },
  },
  mounted() {
    this.refreshProAdvantage();
  },
  methods: {
    refreshProAdvantage() {
      if (this.$i18n.locale === "en")
        this.proAdvantage = Advantages.en[(Math.random() * 4).toFixed(0)];
      else
        this.proAdvantage = Advantages.es[(Math.random() * 4).toFixed(0)];
    },
    upgrade() {
      this.$router.push("/subscription-plans");
    }
  }
}
</script>

<i18n>
{
  "en": {
    "message": "Upgrade to Pro Now"
  },
  "es": {
    "message": "Conviértete a Pro Ahora"
  }
}
</i18n>

<style scoped>
.convert-now-btn {
  font-size: 10px !important;
  background-color: #111111 !important;
  color: #FFFFFF !important;
  border: 1px solid #111111 !important;
}
</style>
